import cms from '@/content'
import { Component } from '@/models/Specialty'
import _ from 'lodash'
import { AgeOption } from '@/models/Content'
import {
  GeneralSurgery,
  SurgeryDiagnosis,
  SurgeryProcedure
} from '../../../models/GeneralSurgery'

export default {
  data() {
    return {
      durationOptions: cms.getDurationOptions()
    }
  },
  methods: {
    allStatsComponents(logbookType) {
      const statsComponents =
        Component.query().where('statistics', true).withAllRecursive().get() ||
        []

      const statsComponentsCpy = JSON.parse(JSON.stringify(statsComponents))
      return statsComponentsCpy.filter(sc =>
        sc.logbooks.some(l => l == logbookType)
      )
    },
    isEqualOrContains(value, stringOrArray, c) {
      if (c.id === 'surgery-procedure') {
        stringOrArray = stringOrArray ? stringOrArray.map(i => i.id) : []
      }

      if (Array.isArray(stringOrArray)) {
        return stringOrArray.some(el => el === value)
      } else {
        return value === stringOrArray
      }
    },
    icd10PossibleValues(filteredLogs, components) {
      const icd10Component = components.find(c => c.type === 'icd10')

      if (icd10Component) {
        return _.uniqBy(
          filteredLogs.flatMap(l => {
            return l[icd10Component.id]
              ? l[icd10Component.id].map(icdValue => ({
                  value: icdValue,
                  text: icdValue
                }))
              : []
          }),
          'value'
        )
      } else {
        return []
      }
    },
    icd10SecPossibleValues(filteredLogs, components) {
      const icd10SecComponent = components.find(c => c.type === 'icd10-sec')

      if (icd10SecComponent) {
        return _.uniq(
          filteredLogs.flatMap(l => {
            return l[icd10SecComponent.id]
              ? l[icd10SecComponent.id].map(icdValue => ({
                  value: icdValue,
                  text: icdValue
                }))
              : []
          })
        )
      } else {
        return []
      }
    },
    getComponentOptions(c, filteredLogs, components) {
      if (c && c.type) {
        if (c.type === 'hint-field-multiple' || c.type === 'hint-field') {
          c.options = _.uniqBy(
            filteredLogs
              .map(l => ({
                text: l[c.id],
                value: l[c.id]
              }))
              .filter(l => l.value),
            'value'
          )
          let newOptions = []
          c.options.map(item => {
            if (Array.isArray(item.value)) {
              item.value.map(o =>
                newOptions.push({
                  text: o,
                  value: o
                })
              )
            } else {
              newOptions.push(item)
            }
          })
          c.options = _.uniqBy(newOptions, 'value')
        }

        if (c.type === 'checkbox') {
          c.options = [{ text: 'Sim', value: true }]
        }

        if (c.type === 'age-field') {
          c.options = AgeOption.query().get()
        }

        if (c.type === 'icd10') {
          c.options = this.icd10PossibleValues(filteredLogs, components)
        }

        if (c.type === 'icd10-sec') {
          c.options = this.icd10SecPossibleValues(filteredLogs, components)
        }

        if (c.type === 'icd10-chapters') {
          c.options = this.icdChapters
        }

        if (c.type === 'icd10-sections') {
          c.options = this.icdSections
        }

        if (c.type === 'icd10-sec-chapters') {
          c.options = this.icdChapters
        }

        if (c.type === 'icd10-sec-sections') {
          c.options = this.icdSections
        }

        if (c.id === 'duration') {
          c.options = this.durationOptions
        }

        if (c.type === 'surgical-autonomy') {
          c.options = components
            .filter(c => c.type === 'autonomy')
            .map(c => ({
              text: c.label,
              value: c.id
            }))
        }

        if (c.id === 'surgery-diagnosis') {
          c.options = SurgeryDiagnosis.all().map(diagnosis => ({
            text: diagnosis.label,
            value: diagnosis.id
          }))
        }

        if (c.id === 'surgery-procedure') {
          c.options = SurgeryProcedure.all().map(procedure => ({
            text: procedure.label,
            value: procedure.id
          }))
        }

        if (c.id === 'anatomic-region') {
          c.options = GeneralSurgery.flattedOrganTree
        }
      }

      return c
    },
    getColumnOptions(dimention, components, filteredLogs) {
      if (!dimention) {
        return []
      }

      if (dimention.id === 'userId') {
        // TODO: no undef
        let users = selectedUsers.length ? selectedUsers : selectedUsers
        return users
      }

      let c = components.find(c => c.id === dimention.id)
      c = this.getComponentOptions(c, filteredLogs, components)

      return c && c.options
        ? c.options.filter(o =>
            filteredLogs.some(l => this.isEqualOrContains(o.value, l[c.id], c))
          )
        : []
    },
    getCount(
      logs,
      { row1, row2, column1, column2 },
      { column1Value, row1Value, column2Value, row2Value }
    ) {
      const matchedLogs = logs.filter(l => {
        return (
          (!row1 ||
            !row1.id ||
            (row1 && this.isEqualOrContains(row1Value, l[row1.id], row1))) &&
          (!row2 ||
            !row2.id ||
            (row2 && this.isEqualOrContains(row2Value, l[row2.id], row2))) &&
          (!column1 ||
            !column1.id ||
            (column1 &&
              this.isEqualOrContains(column1Value, l[column1.id], column1))) &&
          (!column2 ||
            !column2.id ||
            (column2 &&
              this.isEqualOrContains(column2Value, l[column2.id], column2)))
        )
      })
      return matchedLogs.length
    },
    ICD10logs(type) {
      const icd10logs = this.logs.map(log => {
        if (log[type]) {
          return log
        }
      })
      return icd10logs.filter(element => {
        return element !== undefined
      })
    },
    romanize(num) {
      if (isNaN(num)) return NaN
      var digits = String(+num).split(''),
        key = [
          '',
          'C',
          'CC',
          'CCC',
          'CD',
          'D',
          'DC',
          'DCC',
          'DCCC',
          'CM',
          '',
          'X',
          'XX',
          'XXX',
          'XL',
          'L',
          'LX',
          'LXX',
          'LXXX',
          'XC',
          '',
          'I',
          'II',
          'III',
          'IV',
          'V',
          'VI',
          'VII',
          'VIII',
          'IX'
        ],
        roman = '',
        i = 3
      while (i--) roman = (key[+digits.pop() + i * 10] || '') + roman
      return Array(+digits.join('') + 1).join('M') + roman
    }
  }
}
